import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { AccountStateAction } from '@account-users/account/models/IAccount';

@Component({
  selector: 'app-account-details-state-dialog',
  templateUrl: './account-details-state-dialog.component.html',
  styleUrls: ['./account-details-state-dialog.component.scss'],
})
export class AccountDetailsStateDialogComponent {
  @Input() message: string;
  @Input() action: AccountStateAction;
  @Output() close = new EventEmitter<void>();
  @Output() confirm = new EventEmitter<AccountStateAction>();

  constructor(public readonly activeModal: NgbActiveModal) {}

  ok() {
    this.activeModal.close();
    this.confirm.emit(this.action);
  }
}
